// Runtime webpack config
import '../../other/WebpackConfig';

import '../../../scss/l1Page.twh.frbe.scss';

// i18n
import i18n from '../../i18n/fr-BE';

import l1Page from './l1Page';

l1Page(i18n);
